import {useState} from "react";
import {Button, Input, Space} from "antd";
import {SearchOutlined} from "@ant-design/icons";

export interface SearchDropdownPropsType {
  ref:any,
  defaultValue: any,
  filterType: string,
  dataIndex: any,
  confirm: () => void,
  handleFilter: (filterValue:any) => void,
  clearFilters: () => void,
  handleFilterReset: () => void,
}

export default function SearchDropdown({ defaultValue, filterType, dataIndex, confirm, handleFilter, clearFilters, handleFilterReset }: SearchDropdownPropsType) {
  const [filterValue, setFilterValue] = useState(defaultValue)

  return (
    <div style={{padding: 8}}>
      <Input
        placeholder={`Search ${dataIndex}`}
        value={filterValue}
        onChange={e => {
          if (filterType === "int")
            setFilterValue(parseInt(e.target.value));
          else
            setFilterValue(e.target.value)
        }}
        onPressEnter={(e) => {
          e.stopPropagation()
          confirm();
          handleFilter(filterValue instanceof String ? filterValue?.trim() : filterValue)
        }}
        style={{width: 188, marginBottom: 8, display: 'block'}}
      />
      <Space>
        <Button size="small"
            style={{width: 90}}
            onClick={() => {
                clearFilters();
                handleFilterReset();
            }}>Reset</Button>
        <Button
            type="primary"
            icon={<SearchOutlined/>}
            size="small"
            style={{width: 90}}
            onClick={() => {
                confirm();
                handleFilter(filterValue instanceof String ? filterValue?.trim() : filterValue)
            }}>Search</Button>
      </Space>
    </div>
  )
}